import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <ContactSection />
        <AboutSection />
        <RankingSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <CommentsSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}